"use client";
import { QueueType } from "@/app/context/GeneratorContext";

interface Props {
  queueType: QueueType;
  translations: any;
}
export default function QueueTypeBadge({ queueType, translations }: Props) {
  return (
    <>
      {queueType === QueueType.Turbo ? (
        <div className="my-auto rounded-sm bg-[#FFCC18] px-1 py-0.5 text-center text-xs font-semibold text-black">
          {translations.turbo}
        </div>
      ) : queueType === QueueType.Video ? (
        <div className="my-auto rounded-sm bg-[#FF6B18] px-1 py-0.5 text-center text-xs font-semibold text-white">
          GIF
        </div>
      ) : queueType === QueueType.Free ? (
        <div className="my-auto rounded-sm bg-[#fff] px-1 py-0.5 text-center text-xs font-semibold text-[#202124]">
          {translations.free}
        </div>
      ) : null}
    </>
  );
}
